import { AuthStoreImpl } from "./auth/auth.store.impl";
export class Stores {
    constructor() {
        this.authStore = new AuthStoreImpl();
    }
}
export const stores = new Stores();
